import { collectionCommand } from 'volta/utils/api';

import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

import BaseModel from './base-model';

import type { ICmdResult } from 'volta/utils/api/jsonapi-types';

import type { IResourceName } from './base-model';
import type { IUpdateQtyForPeriodInput } from './types/forecasts';

export const DemandForecastResourceName: IResourceName = {
  singular: 'demandForecast',
  plural: 'demandForecasts'
};

export enum DemandForecastQueries {
  tsBySku = 'tsBySku'
}

export enum DemandForecastCommands {
  UpdateQtyForPeriod = 'UpdateQtyForPeriod'
}

export default class DemandForecast extends BaseModel {
  // TODO - Remove when investigation on
  // why it only disappears on Planning model is done
  static modelName = 'demand-forecast';

  /**
   * Collection commands
   */
  static updateQtyForPeriod = collectionCommand<
    IUpdateQtyForPeriodInput,
    ICmdResult<{ updatedIds: string[] }>,
    typeof DemandForecast
  >(DemandForecastCommands.UpdateQtyForPeriod);

  @attr('string') inventoryId!: string; // = SKU ID
  @attr('string') forecastDate!: string;
  @attr('number') demandQty!: number;
  @attr('string') forecastType?: string;
  @attr('string') parentSkuId?: string;
  @attr('string') planningOrderId?: string;

  [Type] = 'demand-forecast' as const;
}
